<mat-card class="cardWithShadow">
  <mat-card-content>
    <div class="row justify-content-between gap-16">
      <div class="col-sm-5">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <input matInput placeholder="{{ 'technicians.search_technician' | translate}}" [formControl]="searchControl"/>
          <mat-icon matSuffix>
            <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
          </mat-icon>
        </mat-form-field>
      </div>
      <div class="col-sm-6 d-flex align-items-center justify-content-end">
        @if (user && user.roles && user.roles.id < Roles.OPERATOR_BO) {
          <button mat-flat-button="" (click)="addTechnician({})" color="primary" mat-ripple-loader-class-name="mat-mdc-button-ripple" class="mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary mat-mdc-button-base">
            <span class="mdc-button__label"> {{ "technicians.add_technician" | translate}} </span>
          </button>
        }
      </div>
    </div>
  </mat-card-content>
</mat-card>
<div class="row">
  @for (technician of filteredTechnicians; track technician.id) {
    <div class="col-sm-6 col-lg-4">
      <app-card-user [technician]="technician" (technicianDeleted)="loadTechnicians()"></app-card-user>
    </div>
  }
  @empty {
    <mat-card class="cardWithShadow bg-white m-16 w-100">
      <mat-card-content>

        <div class="row justify-content-between p-l-24 p-r-24 gap-16">
          <div class="col-sm-8">
            <mat-card-title>{{ "technicians.sorry" | translate}}</mat-card-title>
            <mat-card-subtitle class="mat-body-1 text-dark m-t-16 lh-24 m-b-24">
              {{ "technicians.no_technician" | translate}}
            </mat-card-subtitle>
          </div>
          <div class="col-sm-2
           text-right d-flex justify-content-end align-items-center">
            <tabler-icon name="exclamation-circle" class="icon-message text-dark"></tabler-icon>
          </div>
        </div>

      </mat-card-content>
    </mat-card>
  }
</div>
